var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIpbrokerBlanco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 319 63",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.1,8.4c1.5,0,2.7,1.2,2.7,2.6c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C7.4,9.5,8.6,8.4,10.1,8.4 z M10.1,16c1.5,0,2.7,1.1,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7C7.4,17.2,8.6,16,10.1,16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.6,8.4c1.5,0,2.7,1.2,2.7,2.6c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7 C14.9,9.5,16.1,8.4,17.6,8.4z M17.6,16c1.5,0,2.7,1.1,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7 C14.9,17.2,16.1,16,17.6,16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.8,56.1H7.8v-32h12.1V56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.7,8.4h19.1c11.7,0,17.5,8.4,17.5,16.8c0,8.5-5.9,16.9-17.4,16.9h-7.1v14H24.7V8.4z M43.7,31.4 c7.3,0.1,7.3-11.9,0-11.8h-7v11.8H43.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57.8,42.8c3.7,0,6.7,3,6.7,6.7c0,3.8-3,6.8-6.7,6.8c-3.7,0-6.7-3-6.7-6.8C51.1,45.8,54.1,42.8,57.8,42.8 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99,30.7c6.5,3.3,7.3,9.4,6.7,13.1c-1.2,7.7-6.4,12.3-17,12.3H69.3V8.4h19.1c9.1,0,15.8,5.5,15.5,14.6 C103.8,25.1,102.4,29,99,30.7z M88.4,27.1c5.9,0,6.1-8.5,0-8.5h-7v8.5H88.4z M88.4,45.5c7.3,0,7.1-9.8,0-9.8h-7v9.8H88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M123,40.9h-2.2v15.2h-12.2V8.4h19.1c9.8,0,17.5,4.5,17.7,15.7c0,8.8-3.6,13.8-9.4,15.6l13,16.4h-15 L123,40.9z M127.9,30.6c7.6,0,7.6-10.9,0-10.9h-7.1v10.9H127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M147.9,24.1c0-11,9.8-16.4,19.7-16.4c9.9,0,19.8,5.5,19.8,16.4v16.3c0,10.9-9.8,16.4-19.7,16.4 c-9.9,0-19.8-5.5-19.8-16.4V24.1z M160,40.4c0,3.5,3.9,5.2,7.8,5.2c3.8,0,7.7-1.8,7.7-5.2V24.1c0-3.7-4-5.4-7.9-5.4 c-3.8,0-7.5,1.9-7.5,5.4V40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M216.2,8.4h15l-18.9,23l18.8,24.7h-15.3l-12.2-17l-0.4,0.5v16.5h-12.1V8.4h12.1v17.7L216.2,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M246.5,27.1h19.3v10.4h-19.3v7.1h21v11.4h-33.2V8.4h33.2v11.3h-21V27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M285.6,40.9h-2.2v15.2h-12.2V8.4h19.1c9.8,0,17.5,4.5,17.7,15.7c0,8.8-3.6,13.8-9.4,15.6l13,16.4h-15 L285.6,40.9z M290.5,30.6c7.6,0,7.6-10.9,0-10.9h-7.1v10.9H290.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIpbrokerBlanco);
export default __webpack_public_path__ + "static/media/logo_ipbroker_blanco.567d88dc2ca547cc37a0b07d8fc7d21a.svg";
export { ForwardRef as ReactComponent };